import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { MODAL_TOKEN, ModalProvider } from '@core';

@Component({
  selector: 'lib-image-preview',
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IonicModule]
})
export class ImagePreviewComponent {
  @Input() imageUrl!: string;

  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);

  close(): void {
    this.modalProvider.dismissAllStoredModals();
  }
}
